import Business from '../components/Business/Business'

const BusinessPage = () => (
    <Business />
)

export default BusinessPage